export const EDITOR_VERSIONS = {
	FABRIC: 'FABRIC',
	TINY_MCE: 'TINY_MCE',
};
